// extracted by mini-css-extract-plugin
export default {"details_book_page":"book-page_details_book_page__vqgpJ"};